import { render, staticRenderFns } from "./TaxStatus.vue?vue&type=template&id=3fdf8ddd&scoped=true"
import script from "./TaxStatus.vue?vue&type=script&lang=js"
export * from "./TaxStatus.vue?vue&type=script&lang=js"
import style0 from "./TaxStatus.vue?vue&type=style&index=0&id=3fdf8ddd&prod&lang=css&scoped=true"
import style1 from "./TaxStatus.vue?vue&type=style&index=1&id=3fdf8ddd&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdf8ddd",
  null
  
)

export default component.exports